import InputFieldBase from "./InputFieldBase";
import {Form, InputGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import classNames from 'classnames';

class InputSearch extends InputFieldBase {
    renderContent = () => {
        const placeHolder = this.placeHolder();
        const inputName = this.getNameFromProps();
        const {onChange} = this.props;

        const sizeClass = this.getSizeFromProps();
        const componentClass = this.getComponentClassName();

        return (
            <InputGroup>
                <Form.Control name={inputName} placeholder={placeHolder} className={classNames(sizeClass, componentClass)} onChange={onChange}/>
                <InputGroup.Append> <InputGroup.Text> <FontAwesomeIcon icon={faSearch}/> </InputGroup.Text> </InputGroup.Append>
            </InputGroup>
        );
    };


    placeHolder = () => this.props.placeHolder ?? 'Search Matches, Leagues, Venue, Team...etc';
    getComponentClassName = () => 'input-field input-search';
    getNameFromProps = () => 'search';
}

export default InputSearch;
